export const UserType = {
    AGENCY_BROKERAGE: 1,
    SERVICE: 2,
    SYSTEM: 3,
    UNDERWRITER: 4
};

export const ClientType = {
    OPERATOR: 'OPERATOR',
    UNDERWRITER: 'UM_HTML_UW',
    AGENT: 'UM_HTML_AGENT',
    UM_STUDIO: 'UM_STUDIO'
};

